<template>
  <div
    @mouseover="dropRightValue = true"
    @mouseleave="dropRightValue = false"
  >
    <!-- Single -->
    <li
      v-if="links.length === 1"
      class="relative mb-0.5 py-1 select-none rounded-sm last:mb-0"
      :class="computeActiveLinkStatus(links[0].url)"
    >
      <a
        v-if="links[0].external"
        :href="links[0].url"
        class="relative z-10 block truncate transition duration-150 "
        :title="links[0].url"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{ 'justify-center p-0': !isSideBarActive, 'md:px-3 md:py-3 lg:px-3': isSideBarActive }"
        >
          <div
            class="flex items-center menu-inner"
            :class="{ 'mx-auto': !isSideBarActive, 'm-0': isSideBarActive }"
          >
            <component
              :is="icon"
              class="size-5"
              :class="{ 'mr-0': !isSideBarActive, 'mr-3': isSideBarActive }"
            />
            <span
              class="hidden ml-1 text-sm font-medium duration-200 lg:sidebar-expanded:opacity-100 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': isSideBarActive }"
            >
              {{ links[0].title }}
            </span>
          </div>
        </div>
      </a>
      <NuxtLink
        v-else
        :to="links[0].url"
        class="relative z-10 block truncate transition duration-150 "
        :title="links[0].url"
        @click="handleSideBarDrop"
      >
        <div
          class="flex items-center py-3 md:py-3"
          :class="{ 'justify-center p-0': !isSideBarActive, 'md:px-3 md:py-3 lg:px-3': isSideBarActive }"
        >
          <div
            class="flex items-center menu-inner"
            :class="{ 'mx-auto': !isSideBarActive, 'm-0': isSideBarActive }"
          >
            <component
              :is="icon"
              class="size-5"
              :class="{ 'mr-0': !isSideBarActive, 'mr-3': isSideBarActive }"
            />
            <span
              class="hidden ml-1 text-sm font-medium duration-200 lg:sidebar-expanded:opacity-100 2xl:opacity-100"
              :class="{ 'md:hidden lg:block': isSideBarActive }"
            >
              {{ links[0].title }}
            </span>
          </div>
        </div>
      </NuxtLink>
      <!-- Dropright Menu -->
      <div
        v-if="dropRightValue"
        class="z-9 absolute left-8 top-0 z-50 flex hover:block min-w-[220px] bg-sidebar-green-primary flex-col md:left-12 lg:left-11"
        :class="{ '!hidden ': isSideBarActive }"
      >
        <div class="flex flex-col p-3">
          <a
            v-if="links[0].external"
            :href="links[0].url"
            class="text-sm"
            :class="computeActiveLinkStatus(links[0].url)"
          >
            {{ links[0].title }}
          </a>
          <NuxtLink
            v-else
            :to="links[0].url"
            class="text-sm"
            :class="computeActiveLinkStatus(links[0].url)"
          >
            {{ links[0].title }}
          </NuxtLink>
        </div>
      </div>
    </li>

    <!-- Multiple with submenu -->
    <li
      v-else
      class="relative mb-0.5 py-1 select-none rounded-sm last:mb-0 bg-sidebar-green-primary"
    >
      <div class="relative z-20 block">
        <div
          class="block text-white truncate transition duration-150 cursor-pointer bg-sidebar-green-primary"
          title="Reporting"
          @click="handleSideBarDrop"
        >
          <div
            class="relative z-10 flex items-center justify-between py-3 md:py-3"
            :class="{
              'justify-center p-0': !isSideBarActive,
              'md:p-3 lg:px-3': isSideBarActive,
            }"
          >
            <div
              class="flex items-center menu-inner"
              :class="{ 'mx-auto': !isSideBarActive, 'm-0': isSideBarActive }"
            >
              <component
                :is="icon"
                class="w-5 h-5"
                :class="{ 'mr-0': !isSideBarActive, 'mr-3': isSideBarActive }"
              />
              <span
                class="hidden ml-1 text-sm font-medium duration-200 lg:sidebar-expanded:opacity-100 2xl:opacity-100"
                :class="{ 'md:hidden lg:block': isSideBarActive }"
              >{{ menuTitle }}</span>
            </div>
            <div
              class="hidden transition-all"
              :class="{
                'md:hidden lg:block': isSideBarActive,
                'rotate-180': submenuIsVisible,
              }"
            >
              <span class="md:ml-2 lg:ml-0">
                <ChevronDownLarge custom-style="size-5" />
              </span>
            </div>
          </div>
        </div>
        <div
          class="transition-[grid-template-rows]"
          :class="{ '!hidden': !isSideBarActive, 'grid': isSideBarActive }"
          :style="{ 'grid-template-rows': submenuIsVisible ? '1fr' : '0fr' }"
        >
          <div
            v-if="submenuIsVisible"
            class="pb-3 overflow-hidden"
          >
            <template
              v-for="({ title, url, external }, lIndex) in visibleLinks"
              :key="title"
            >
              <a
                v-if="external"
                :href="url"
                class="transition duration-150 blocktruncate"
                :class="computeActiveLinkStatus(url)"
                :title="title"
              >
                <div class="flex items-center menu-child">
                  <span
                    class="hidden pl-4 ml-8 text-sm font-medium duration-200 border-l lg:sidebar-expanded:opacity-100 2xl:opacity-100"
                    :class="{ 'md:hidden lg:block': isSideBarActive, 'pb-2.5': lIndex === 0, 'pt-2.5': lIndex === visibleLinks.length - 1, 'py-2.5': lIndex > 0 && lIndex !== visibleLinks.length - 1 }"
                  >
                    {{ title }}
                  </span>
                </div>
              </a>
              <NuxtLink
                v-else
                :to="url"
                class="transition duration-150 blocktruncate"
                :class="computeActiveLinkStatus(url)"
                :title="title"
              >
                <div class="flex items-center menu-child">
                  <span
                    class="hidden pl-4 ml-8 text-sm font-medium duration-200 border-l lg:sidebar-expanded:opacity-100 2xl:opacity-100"
                    :class="{ 'md:hidden lg:block': isSideBarActive, 'pb-2.5': lIndex === 0, 'pt-2.5': lIndex === visibleLinks.length - 1, 'py-2.5': lIndex > 0 && lIndex !== visibleLinks.length - 1 }"
                  >
                    {{ title }}
                  </span>
                </div>
              </NuxtLink>
            </template>
          </div>
        </div>
      </div>

      <!-- Dropright Menu -->
      <div
        v-if="dropRightValue"
        class="z-9 absolute left-8 top-0 flex min-w-[220px] bg-sidebar-green-primary flex-col gap-y-2 md:left-12 lg:left-11"
        :class="{ '!hidden': isSideBarActive }"
      >
        <div class="flex flex-col">
          <div class="w-full p-3 pb-0">
            <span class="text-sm font-medium text-white hover:[#FF8024]">{{ menuTitle }}</span>
            <div class="mt-3 h-0.5 w-full bg-gray-100/10" />
          </div>
          <div class="flex flex-col p-4 gap-y-4 bg-sidebar-green-primary">
            <template
              v-for="{ title, url, external } in visibleLinks"
              :key="title"
            >
              <a
                v-if="external"
                :href="url"
                class="text-sm"
                :class="computeActiveLinkStatus(url)"
              >
                {{ title }}
              </a>
              <NuxtLink
                v-else
                :to="url"
                class="text-sm"
                :class="computeActiveLinkStatus(url)"
              >
                {{ title }}
              </NuxtLink>
            </template>
          </div>
        </div>
      </div>
    </li>
  </div>
</template>

<script>
export default {
  name: 'SidebarMenuItem',

  props: {
    itemLinks: {
      type: Array,
      required: true,
    },
    icon: {
      type: [String, Object],
      required: true,
    },
    menuTitle: {
      type: String,
      default: '',
    },
    dropRight: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['toggle-menu'],

  data() {
    return {
      links: this.transformLinks(this.itemLinks),
      dropRightValue: false,
      submenuIsVisible: this.dropRight,
    }
  },

  computed: {
    visibleLinks() {
      return [...this.links].filter(({ hidden }) => !hidden)
    },
    isSideBarActive() {
      return this.$store.sidebar.responsiveActive
    },
  },

  watch: {
    itemLinks(newItemLinks) {
      this.links = this.transformLinks(newItemLinks)
    },
    dropRight(newDropRight) {
      this.submenuIsVisible = newDropRight
    },
  },

  methods: {
    handleSideBarDrop() {
      this.submenuIsVisible = !this.submenuIsVisible
      this.$emit('toggle-menu', this.submenuIsVisible)
    },
    transformLinks(items) {
      return [...items].map((linkObject) => {
        if (linkObject.hidden === undefined) {
          linkObject.hidden = false
        }
        return linkObject
      })
    },
    computeActiveLinkStatus(url) {
      return {
        'text-[#FF8024]': this.$route.path === url || this.$route.path.startsWith(`${url}/`),
        'text-white hover:text-[#FF8024]': !(this.$route.path === url || this.$route.path.startsWith(`${url}/`)),
      }
    },
  },
}
</script>
